module.exports = __webpack_public_path__ + "img/65.4eb9768f.jpg";